
import { useEffect, useRef, useState } from 'react'
import {
  Table,
  Container,
  Row,
  Col,
  Card,
  Image,
  Button,
} from 'react-bootstrap'
import { FaEdit, FaPrint, FaArrowLeft } from 'react-icons/fa'
import { FaDownload } from 'react-icons/fa'
import { BsFunnelFill, BsSearch, BsArrowClockwise, BsFileEarmarkText } from 'react-icons/bs'
import { LuGraduationCap } from 'react-icons/lu'
import Cookies from 'js-cookie'

import Form from 'react-bootstrap/Form'
import ApiEndpoints, {BASE_URL, BASE_URL_Upload} from './commonComponents/ApiEndpoints'
import axios from 'axios'
import { Typeahead } from 'react-bootstrap-typeahead'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import html2pdf from 'html2pdf.js';
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import { useInstitute } from './commonComponents/InstituteContext'

const DEFAULT_STUDENT_PHOTO = '/studentprofile.jpg'

const pickStudentImageRaw = (...candidates) => {
  for (const raw of candidates) {
    if (
      raw != null &&
      String(raw).trim() !== '' &&
      String(raw).toLowerCase() !== 'null' &&
      String(raw).toLowerCase() !== 'undefined'
    ) {
      return String(raw).trim()
    }
  }
  return ''
}

/** Use API student_image as-is (storage URLs are valid). */
const resolveStudentImageSrc = (raw) => {
  const picked = pickStudentImageRaw(raw)
  if (!picked) return DEFAULT_STUDENT_PHOTO
  let url = picked.replace(/^http:\/\//i, 'https://')
  if (url.startsWith('data:') || /^https?:\/\//i.test(url)) return url
  if (url.startsWith('//')) return `https:${url}`
  const base = String(BASE_URL_Upload || '').replace(/\/$/, '')
  const path = url.startsWith('/') ? url : `/${url}`
  return base ? `${base}${path}` : url
}

export default function ExamMarksheet({ hideFilters = false } = {}) {
  const {token, logout} = useAuth()
  const { isCollapsed } = useSidebar()
  const institute_id = Cookies.get('institute_id')
  
  const [instituteName, setInstitutename] = useState()
  const [institues, setInstitutes] = useState([])
  const [instituteAddress, setInstituteAddress] = useState()
  const [institutePincode, setInstitutePincode] = useState()
  const [instituteId, setInstituteId] = useState()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id } = useInstitute();
  const cookieInstituteId = String(Cookies.get('institute_id') || '').trim()
  const hideNctBranding = cookieInstituteId != '12'
  const [showFilterCard, setShowFilterCard] = useState(!hideFilters)
  const [noMarksheetFromProfile, setNoMarksheetFromProfile] = useState(false)
  const [emptyStateToolbarDismissed, setEmptyStateToolbarDismissed] =
    useState(false)
  const [toolbarGenerateHiddenByRefresh, setToolbarGenerateHiddenByRefresh] =
    useState(false)

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  useEffect(() => {
    // `InstituteContext` persists the institute name in the `name` cookie.
    // Some older flows used `institute_name`, so we support both.
    const storedInstitute = Cookies.get('name') || Cookies.get('institute_name')
    const storedInstituteId = Cookies.get('institute_id')
    console.log('storedInstituteId', storedInstituteId)
    if (storedInstituteId) setInstituteId(storedInstituteId)

    if (storedInstitute) setInstitutename(storedInstitute)
    else if (name) setInstitutename(name)

    ApiEndpoints.getAllInstitutes().then((res) => {
      console.log('List of Institutes: ', res.data.data)
      const instituteData = res.data.data
      setInstitutes(instituteData)
      if (storedInstituteId) {
        const matchedInstitute = instituteData.find(
          (inst) => String(inst.institute_id) === String(storedInstituteId),
        )
        console.log('matchedInstitute', matchedInstitute)
        const resolvedName =
          matchedInstitute?.name ||
          matchedInstitute?.institute_name ||
          storedInstitute ||
          name
        if (resolvedName) setInstitutename(resolvedName)
        setInstituteAddress(matchedInstitute?.address)
        setInstitutePincode(matchedInstitute?.pincode)
      }
    })
  }, [name])

  const [showMarksheet, setShowMarksheet] = useState(false)

  const routeParams = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const student_id = routeParams.student_id || routeParams.studentId
  // From /student/:id/marksheets/:examId (list → View), like certificates/:certificateId
  const examIdParam = routeParams.examId
  const [resolvedCourseId, setResolvedCourseId] = useState(null)
  const [resolvedClassId, setResolvedClassId] = useState(null)
  const course_id =
    routeParams.course_id ||
    // Do not treat :examId as courseId (student marksheets view route)
    (examIdParam ? null : routeParams.courseId) ||
    location.state?.course_id ||
    location.state?.courseId ||
    resolvedCourseId
  const class_id =
    routeParams.class_id ||
    (examIdParam ? null : routeParams.classId) ||
    location.state?.class_id ||
    location.state?.classId ||
    resolvedClassId
  console.log(
    student_id,
    course_id,
    class_id,
    'Type of Class Id: ',
    typeof class_id,
  )
  const [processedSubjects, setProcessedSubjects] = useState([]);
  const [courses, setCourses] = useState([])
  const [classes, setClasses] = useState([])
  const [students, setStudents] = useState([])
  const [allStudents, setAllStudents] = useState([])
  const [selectedCourse, setSelectedCourse] = useState()
  const [selectedClass, setSelectedClass] = useState()
  // const[selectedExamId,setSelectedExamId]=useState("")
  const [selectedStudent, setSelectedStudent] = useState()
  const [selectedStudentName, setSelectedStudentName] = useState('')
  const [data, setData] = useState([])
  const [img, setImg]=useState(null)
  const [overallTotals, setOverallTotals] = useState({});

  const componentRef = useRef()

  // When opened from /student/:id/marksheets/:examId without state (refresh),
  // resolve course/class from marksheets API — same idea as certificates view.
  useEffect(() => {
    if (!hideFilters || !student_id || !examIdParam) return
    if (course_id && class_id) return

    let cancelled = false
    const resolveFromMarksheets = async () => {
      try {
        const res = await ApiEndpoints.getStudentMarksheets(student_id)
        if (cancelled) return
        const payload = res?.data || {}
        const msStudent = payload.student || null
        const rows = Array.isArray(payload.data) ? payload.data : []
        const match = rows.find(
          (row) => Number(row?.exam_id) === Number(examIdParam),
        )
        const nextCourse =
          match?.course_id ??
          match?.course?.id ??
          msStudent?.course_id ??
          null
        const nextClass =
          match?.class_id ??
          match?.class?.id ??
          msStudent?.class_id ??
          null
        if (nextCourse) setResolvedCourseId(Number(nextCourse))
        if (nextClass) setResolvedClassId(Number(nextClass))
        if (msStudent) {
          const photo = pickStudentImageRaw(
            msStudent.student_image,
            location.state?.studentImage,
          )
          setImg((prev) => ({
            ...(prev || {}),
            ...msStudent,
            id: Number(msStudent.id ?? student_id),
            student_image:
              pickStudentImageRaw(prev?.student_image) || photo || null,
          }))
        }
      } catch (err) {
        console.warn('Failed to resolve course/class from marksheets API:', err)
      }
    }

    resolveFromMarksheets()
    return () => {
      cancelled = true
    }
    // course_id/class_id intentionally omitted once resolved to avoid loops
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hideFilters, student_id, examIdParam, location.state?.studentImage])
  
  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
  }, [])

  // Fetch all students on mount (similar to ViewAttendance.js)
  useEffect(() => {
    const fetchAllStudents = async () => {
      try {
        const institueId = Cookies.get('institute_id')
        const userCookie = Cookies.get('user')

        let token = null
        if (userCookie) {
          try {
            const user = JSON.parse(userCookie)
            token = user.token
            console.log('TOKEN:', token)
          } catch (error) {
            console.error('Failed to parse user cookie', error)
          }
        }
        
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'institute-Id': institute_id || institueId,
        }

        const response = await axios.get(
          BASE_URL + '/student/all',
          { headers },
        )
        console.log('Response of all students:', response.data.data)
        setAllStudents(response.data.data)
      } catch (error) {
        console.error(error.response?.data?.message || 'Something went wrong.')
      }
    }
    fetchAllStudents()
  }, [])

  const calculateOverallTotals = (data) => {
  let totalObtained = 0;
  let totalMax = 0;

  data.forEach((entry) => {
    const marks = parseFloat(entry.marks);
    const totalMarks = entry.exam.total_marks;

    totalObtained += marks;
    totalMax += totalMarks;
  });

  const percentage = ((totalObtained / totalMax) * 100).toFixed(2);

  return {
    totalObtained,
    totalMax,
    percentage,
  };
};

  const fetchData = async () => {
    try {
      const res = await ApiEndpoints.getStudentExamMarks(
        selectedStudent,
        Number(selectedCourse),
      )
      console.log('Images see from this data:', res.data.data)
      const list = res.data.data || []
      setData(list)
      setImg((prev) => {
        const markStudent = list[0]?.student
        if (!markStudent) {
          return prev || null
        }
        const keptPhoto = pickStudentImageRaw(
          markStudent.student_image,
          prev?.student_image,
          location.state?.studentImage,
          location.state?.student?.student_image,
        )
        return {
          ...(prev || {}),
          ...markStudent,
          student_image: keptPhoto || markStudent.student_image || null,
        }
      })
      if (list[0]?.student) {
        const markStudent = {
          ...list[0].student,
          name:
            list[0].student.name ||
            `Student #${list[0].student.id || selectedStudent}`,
        }
        if (markStudent.name) setSelectedStudentName(markStudent.name)
        setStudents((prev) => {
          const listStudents = Array.isArray(prev) ? prev : []
          const sid = Number(markStudent.id || selectedStudent)
          const idx = listStudents.findIndex((s) => Number(s.id) === sid)
          if (idx === -1) return [...listStudents, markStudent]
          const next = [...listStudents]
          next[idx] = { ...next[idx], ...markStudent }
          return next
        })
      }
      const response = list
      const processedSubjects = processSubjectData(response)
      setProcessedSubjects(processedSubjects)

      const overallTotals = calculateOverallTotals(response)
      setOverallTotals(overallTotals)

      const fromProfile = !!location.state?.fromStudentProfile || hideFilters
      const matchesUrlParams =
        fromProfile &&
        student_id &&
        course_id &&
        Number(selectedStudent) === Number(student_id) &&
        Number(selectedCourse) === Number(course_id)

      if (matchesUrlParams) {
        if (list.length > 0) {
          setShowMarksheet(true)
          setNoMarksheetFromProfile(false)
        } else {
          setShowMarksheet(false)
          setNoMarksheetFromProfile(true)
        }
      } else {
        if (fromProfile) {
          setNoMarksheetFromProfile(false)
        }
        if (list.length > 0) {
          setShowMarksheet(true)
        } else {
          setShowMarksheet(false)
        }
      }
    } catch (error) {
      console.error(error.response?.data?.message)
      const fromProfile = !!location.state?.fromStudentProfile || hideFilters
      const matchesUrlParams =
        fromProfile &&
        student_id &&
        course_id &&
        Number(selectedStudent) === Number(student_id) &&
        Number(selectedCourse) === Number(course_id)
      if (matchesUrlParams) {
        setNoMarksheetFromProfile(true)
        setShowMarksheet(false)
      }
    }
  }
  useEffect(() => {
    if (selectedStudent && selectedCourse) {
      fetchData()
    }
  }, [selectedStudent, selectedCourse])

  // Load full student profile photo (exam marks API often omits student_image)
  useEffect(() => {
    if (!student_id) return
    let cancelled = false

    const applyPhoto = (source, extra = {}) => {
      const photo = pickStudentImageRaw(
        source?.student_image,
        source?.image,
        source?.photo,
        source?.profile_image,
      )
      if (!photo) return false
      setImg((prev) => ({
        ...(prev || {}),
        ...extra,
        ...(source && typeof source === 'object' ? source : {}),
        id: Number(source?.id ?? student_id),
        student_image: pickStudentImageRaw(prev?.student_image) || photo,
      }))
      return true
    }

    const loadStudentPhoto = async () => {
      const seedImage = pickStudentImageRaw(
        location.state?.studentImage,
        location.state?.student?.student_image,
        location.state?.student?.image,
      )
      if (seedImage) {
        setImg((prev) => ({
          ...(prev || {}),
          id: Number(student_id),
          student_image: pickStudentImageRaw(prev?.student_image) || seedImage,
        }))
      }

      const fromAll = allStudents.find(
        (s) => Number(s.id) === Number(student_id),
      )
      applyPhoto(fromAll)

      // Prefer /student/all photo (same source StudentProfile uses)
      try {
        const institueId = Cookies.get('institute_id')
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'institute-Id': institute_id || institueId,
        }
        const allRes = await axios.get(BASE_URL + '/student/all', { headers })
        if (cancelled) return
        const list = Array.isArray(allRes?.data?.data) ? allRes.data.data : []
        const match = list.find((s) => Number(s.id) === Number(student_id))
        applyPhoto(match)
      } catch (err) {
        console.warn('Failed to load student photo from /student/all:', err)
      }

      try {
        const res = await ApiEndpoints.viewProfile(student_id)
        if (cancelled) return
        const profile = res?.data?.data || res?.data?.student || res?.data
        if (profile && typeof profile === 'object') {
          applyPhoto(profile)
        }
      } catch (err) {
        console.warn('Failed to load student profile photo for marksheet:', err)
      }

      // Last resort: marksheets list payload includes student.student_image
      try {
        const msRes = await ApiEndpoints.getStudentMarksheets(student_id)
        if (cancelled) return
        const msStudent = msRes?.data?.student
        applyPhoto(msStudent)
      } catch (err) {
        console.warn('Failed to load student photo from marksheets API:', err)
      }
    }

    loadStudentPhoto()
    return () => {
      cancelled = true
    }
  }, [
    student_id,
    allStudents,
    token,
    institute_id,
    location.state?.studentImage,
    location.state?.student?.student_image,
  ])

  // Auto-populate dropdowns when navigated from StudentProfile (similar to ViewAttendance.js)
  useEffect(() => {
    if (!(student_id && course_id && class_id && courses.length > 0)) return

    console.log('✅ useEffect triggered with params:')
    console.log('student_id:', student_id)
    console.log('course_id:', course_id)
    console.log('class_id:', class_id)

    const student = allStudents.find(
      (s) => Number(s.id) === Number(student_id),
    )
    console.log('Found student:', student)

    // Always seed from URL so marksheet loads even if student is missing from /student/all
    setSelectedCourse(Number(course_id))
    setSelectedClass(Number(class_id))
    setSelectedStudent(Number(student_id))
    if (student?.name) {
      setSelectedStudentName(student.name)
    }
    const photoFromAll = pickStudentImageRaw(student?.student_image)
    if (photoFromAll) {
      setImg((prev) => ({
        ...(prev || {}),
        ...(student || {}),
        id: Number(student_id),
        student_image: pickStudentImageRaw(prev?.student_image) || photoFromAll,
      }))
    }

    ApiEndpoints.getAllClassesByCourseId(Number(course_id))
      .then((res) => {
        console.log('Classes fetched for course:', res.data.data)
        setClasses(res.data.data || [])
      })
      .catch((error) => {
        console.error('Error fetching classes:', error)
      })

    const institueId = Cookies.get('institute_id')
    const headers = {
      'institute-Id': institueId || institute_id,
      Authorization: `Bearer ${token}`,
    }
    axios
      .get(BASE_URL + `/get/student/by-class?class_id=${class_id}`, { headers })
      .then((res) => {
        const list = Array.isArray(res.data?.data) ? res.data.data : []
        console.log('Students after class select:', list)
        const matchedStudent =
          list.find((st) => Number(st.id) === Number(student_id)) || student
        const fallback = {
          id: Number(student_id),
          name:
            matchedStudent?.name ||
            student?.name ||
            `Student #${student_id}`,
        }
        const withStudent =
          matchedStudent &&
          !list.some((st) => Number(st.id) === Number(student_id))
            ? [...list, { ...fallback, ...matchedStudent, name: matchedStudent?.name || fallback.name }]
            : list.length > 0
              ? list.map((st) => ({
                  ...st,
                  name: st?.name || `Student #${st?.id ?? ''}`,
                }))
              : [{ ...fallback, ...(matchedStudent || {}) }]
        setStudents(withStudent)
        const studentName = matchedStudent?.name || student?.name
        if (studentName) setSelectedStudentName(studentName)
      })
      .catch((error) => {
        console.error('Error fetching students:', error)
        if (student) {
          setStudents([
            { ...student, name: student?.name || `Student #${student_id}` },
          ])
          if (student?.name) setSelectedStudentName(student.name)
        } else {
          setStudents([
            { id: Number(student_id), name: `Student #${student_id}` },
          ])
        }
      })
  }, [allStudents, student_id, course_id, class_id, courses, token, institute_id])

  useEffect(() => {
    if (hideFilters) {
      setShowFilterCard(false)
      return
    }
    if (noMarksheetFromProfile && !emptyStateToolbarDismissed) {
      setShowFilterCard(false)
    }
  }, [hideFilters, noMarksheetFromProfile, emptyStateToolbarDismissed])

  useEffect(() => {
    setEmptyStateToolbarDismissed(false)
    setToolbarGenerateHiddenByRefresh(false)
  }, [student_id, course_id, class_id])

  useEffect(() => {
    const isBaseExamMarksheetRoute =
      location.pathname === '/ExamMarksheet' ||
      location.pathname === '/ExamMarksheet/'
    if (isBaseExamMarksheetRoute) {
      setSelectedCourse(null)
      setSelectedClass(null)
      setSelectedStudent(null)
      setSelectedStudentName('')
      setShowMarksheet(false)
      setData([])
      setProcessedSubjects([])
      setOverallTotals({})
      setImg(null)
      setShowFilterCard(!hideFilters)
      setNoMarksheetFromProfile(false)
      setEmptyStateToolbarDismissed(false)
      setToolbarGenerateHiddenByRefresh(false)
    }
  }, [location.pathname, location.key, hideFilters])

  const handleCourseChange = (e) => {
    const courseId = e.target.value
    console.log('selected course id:', courseId)
    setSelectedCourse(courseId)
    if (courseId) {
      ApiEndpoints.getAllClassesByCourseId(courseId).then((res) => {
        console.log('Classes after course:', res.data.data)
        setClasses(res.data.data)
      })
    }
  }

  const handleClassChange = (e) => {
    const classId = e.target.value
    console.log(
      'Selected class id',
      classId,
      'Type of Selected Class Id:',
      typeof classId,
    )
    setSelectedClass(classId)
    if (classId) {
       const institueId = Cookies.get('institute_id')
            const headers = {
              'institute-Id': institueId || institute_id,
              Authorization: `Bearer ${token}`
            }
      axios
        .get(
          BASE_URL+`/get/student/by-class?class_id=${classId}`,
          { headers },
        )
        .then((res) => {
          console.log('Students after class:', res.data.data)
          setStudents(res.data.data)
        })
    }
  }

  const handleStudentChange = (e) => {
    const studentId = e.target.value
    console.log('Selected Student:', studentId)
    setSelectedStudent(studentId)
    const studentName = students.find((st) => st.id === Number(studentId))?.name
    console.log('studentName:', studentName)
    setSelectedStudentName(studentName)
    if (studentId) {
      setShowMarksheet(true)
      // fetchData()
    }
  }

  console.log(
    'Filtered selected class:',
    classes.filter((cs) => cs.id === Number(class_id)),
  )

  const handleStudentMarksheet = () => {
    setShowMarksheet(true)
  }

  const handleEditMarksheet = (examId) => {
    const filteredData = data.filter((entry) => entry.exam_id === examId)

    navigate(
      `/AddExamResult/${selectedStudent}/${selectedCourse}/${selectedClass}`,
      { state:{
        data:filteredData,
        selectedExamId:examId
      }}
    )
    console.log("Data from examarksheet to addexamresult:", data)
  }
  const handleRefresh = () => {
    setSelectedCourse(null)
    setSelectedClass(null)
    setSelectedStudent(null)
    setSelectedStudentName('')
    setShowMarksheet(false)
    setData([])
    setProcessedSubjects([])
    setOverallTotals({})
    setImg(null)
    if (location.state?.fromStudentProfile || hideFilters) {
      setToolbarGenerateHiddenByRefresh(true)
    }
  }
  console.log('Student Id:', selectedStudent)
  console.log('Course Id:', selectedCourse)
  console.log('Class Id:', selectedClass)


  const examNames = [...new Set(data.map(item => item.exam?.exam_name))]

   // 2. Get unique subjects and group their exam marks
  //  const subjectMap = {}

  //  data.forEach(item => {
  //    const subjectName = item.subject?.subject_name || 'N/A'
  //    const examName = item.exam?.exam_name
  //    const marks = item.marks
  //    const status = item.status
 
  //    if (!subjectMap[subjectName]) {
  //      subjectMap[subjectName] = {
  //        exams: {},
  //        status,
  //      }
  //    }
 
  //    subjectMap[subjectName].exams[examName] = marks
  //  })
 
  //  const subjects = Object.entries(subjectMap)
 

  const processSubjectData = (data) => {
    const subjectMap = {};
  
    data.forEach((entry) => {
      const subjectId = entry.subject_id;
      const subjectName = entry.subject.subject_name;
      const examName = entry.exam.exam_name;
      const marks = parseFloat(entry.marks);
      const status = entry.status;
      const totalMarks = entry.exam.total_marks;
  
      if (!subjectMap[subjectId]) {
        subjectMap[subjectId] = {
          subjectId,
          subjectName,
          exams: {},
          totalMarksObtained: 0,
          totalExamCount: 0,
          statusList: [],
          maxTotalMarks: 0,
        };
      }
  
      subjectMap[subjectId].exams[examName] = {
        marks,
        totalMarks,
      };
  
      subjectMap[subjectId].totalMarksObtained += marks;
      subjectMap[subjectId].totalExamCount += 1;
      subjectMap[subjectId].statusList.push(status);
      subjectMap[subjectId].maxTotalMarks = totalMarks; // assuming same across
    });
  
    // Now map into array
    return Object.values(subjectMap).map((subject) => {
      const average = (subject.totalMarksObtained / subject.totalExamCount).toFixed(2);
      const finalStatus = subject.statusList.includes("fail") ? "Fail" : "Pass";
  
      return {
        subjectId: subject.subjectId,
        subjectName: subject.subjectName,
        exams: subject.exams,
        average,
        finalStatus,
      };
    });
  };
  

  
// Before rendering table, define:
const uniqueExams = Array.from(
  new Map(
    data.map((item) => [item.exam_id, item.exam.exam_name,])
  ).entries()
)
const examTotalMarksMap = new Map()
data.forEach((item)=>{
  examTotalMarksMap.set(item.exam.exam_name, item.exam.total_marks)
})



const handleDownload = () => {
  const element = document.getElementById('download_page');
  if (!element) return;

  element.classList.add('download-style');
  
  const tableFooter = element.querySelector('.table-footer-download');
  const printCard = element.querySelector('.print-card-download');
  
  if (tableFooter && printCard) {
    // Force the footer to be at the very bottom
    tableFooter.style.position = 'absolute';
    tableFooter.style.bottom = '40px'; // Increased from 20px
    tableFooter.style.left = '20px';
    tableFooter.style.right = '20px';
    tableFooter.style.borderTop = 'none'; // Remove any border
    
    const cardHeight = printCard.offsetHeight;
    const contentHeight = printCard.scrollHeight - tableFooter.offsetHeight;
    
    // If content is short, add more spacer to push footer down
    if (contentHeight < cardHeight - 150) {
      const spacer = document.createElement('div');
      spacer.className = 'footer-spacer';
      // Increase spacer height to push footer more
      spacer.style.height = (cardHeight - contentHeight - 80) + 'px'; // Increased from 50px
      spacer.style.width = '100%';
      tableFooter.parentNode.insertBefore(spacer, tableFooter);
    }
  }

  const opt = {
    margin: 0,
    filename: `${selectedStudentName || 'student'}_marksheet.pdf`,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { 
      scale: 2, 
      useCORS: true,
      height: 1120,
      onclone: (clonedDoc) => {
        const clonedElement = clonedDoc.getElementById('download_page');
        if (clonedElement) {
          clonedElement.classList.add('download-style');
          
          const clonedCard = clonedElement.querySelector('.print-card-download');
          const clonedFooter = clonedElement.querySelector('.table-footer-download');
          
          if (clonedCard && clonedFooter) {
            // Remove border and position at bottom
            clonedFooter.style.position = 'absolute';
            clonedFooter.style.bottom = '40px'; // Increased
            clonedFooter.style.left = '20px';
            clonedFooter.style.right = '20px';
            clonedFooter.style.borderTop = 'none';
            
            // Remove any existing spacer
            const existingSpacer = clonedElement.querySelector('.footer-spacer');
            if (existingSpacer) existingSpacer.remove();
            
            // Add larger spacer for more bottom positioning
            const cardRect = clonedCard.getBoundingClientRect();
            const footerRect = clonedFooter.getBoundingClientRect();
            
            if (footerRect.top < cardRect.height - 80) {
              const spacer = clonedDoc.createElement('div');
              spacer.className = 'footer-spacer';
              spacer.style.height = (cardRect.height - footerRect.top - 80) + 'px'; // Increased
              spacer.style.width = '100%';
              clonedFooter.parentNode.insertBefore(spacer, clonedFooter);
            }
          }
        }
      }
    },
    jsPDF: { 
      unit: 'mm', 
      format: 'a4', 
      orientation: 'portrait'
    }
  };

  html2pdf().set(opt).from(element).save().finally(() => {
    element.classList.remove('download-style');
    const spacers = element.querySelectorAll('.footer-spacer');
    spacers.forEach(spacer => spacer.remove());
  });
};

  const handlePrint = () => {
    const element = document.getElementById('print_page');
    if (!element) return;
    element.classList.add('pdf-style');
    setTimeout(() => {
      window.print();
      element.classList.remove('pdf-style');
    }, 200);
  };

  const fromStudentProfile =
    !!location.state?.fromStudentProfile || hideFilters
  const isBaseExamMarksheetRoute =
    location.pathname === '/ExamMarksheet' || location.pathname === '/ExamMarksheet/'
  const showNoMarksheetMessage =
    fromStudentProfile &&
    noMarksheetFromProfile &&
    !emptyStateToolbarDismissed
  const hasMarksheetData = showMarksheet && data.length > 0
  const showToolbarGenerateButton =
    !hideFilters &&
    !isBaseExamMarksheetRoute &&
    !(fromStudentProfile && hasMarksheetData) &&
    !(
      fromStudentProfile &&
      noMarksheetFromProfile &&
      emptyStateToolbarDismissed
    ) &&
    !(fromStudentProfile && toolbarGenerateHiddenByRefresh)
  // No Go Back on /student/:id/marksheets/:course/:class (opened via list View)
  const showGoBackToolbar =
    !hideFilters && fromStudentProfile && student_id && !hasMarksheetData

  const handleToolbarGenerateClick = () => {
    if (hideFilters) return
    if (selectedStudent && selectedCourse && selectedClass) {
      navigate(
        `/AddExamResult/${selectedStudent}/${selectedCourse}/${selectedClass}`,
      )
    } else {
      navigate('/AddExamResult')
    }
  }

  return (
    <>
    <style>

{
  `
  .filter-card-container {
    overflow: visible !important;
    position: relative !important;
    z-index: 1 !important;
  }
  
  .filter-card-container .card {
    overflow: visible !important;
    position: relative !important;
  }
  
  .filter-card-container .card-body {
    overflow: visible !important;
    position: relative !important;
  }
  
  .filter-card-container .row {
    overflow: visible !important;
    position: relative !important;
  }
  
  .filter-card-container .col {
    overflow: visible !important;
    position: relative !important;
  }

  .rbt-menu {
    z-index: 9999 !important;
    position: absolute !important;
    max-height: 300px !important;
    overflow-y: auto !important;
  }
  
  .rbt-input-wrapper {
    position: relative !important;
    z-index: 1 !important;
  }
  
  .rbt-input-hint {
    z-index: 1 !important;
  }
  
  .rbt-input-main {
    z-index: 2 !important;
  }
  
  .rbt-menu.show {
    z-index: 9999 !important;
  }
  
  /* Ensure Typeahead dropdown appears above everything */
  .rbt-menu.dropdown-menu {
    z-index: 9999 !important;
    position: absolute !important;
  }

  /* ✅ Base Card */
.print-card {
  position: relative;
  background-color: white;
  overflow: hidden;
}

/* ✅ Watermark inside card (visible in UI) */
.print-card .watermark-logo-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: auto;
  opacity: 0.08; /* very soft — text/tables stay primary */
  z-index: 0;
  pointer-events: none;
}

.print-card .watermark-logo {
  width: 100%;
  height: auto;
  object-fit: contain;
  object-position: center;
}

/* ✅ Content above watermark */
.print-card > *:not(.watermark-logo-wrapper):not(.watermark-logo),
.print-card table,
.print-card h2,
.print-card h4,
.print-card h5,
.print-card p {
  position: relative;
  z-index: 2;
}

/* ✅ Transparent background for table */
.print-card table,
.print-card th,
.print-card td {
  background-color: transparent !important;
  z-index: 1 !important;
}


/* ✅ PRINT STYLES — aligned with TemplateBasedCertificate / ExamMarksheetPrint */
@media print {
  body,
  html {
    margin: 0 !important;
    padding: 0 !important;
    font-size: 13px !important;
    overflow: hidden !important;
    background: #ffffff !important;
  }

  body:has(#print_page) .App {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
  }

  body:has(#print_page) .app-main-content {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    flex: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  /* Hide sidebar and navigation completely */
  aside, nav, .sidebar, [class*="sidebar"], [class*="Sidebar"],
  [class*="Sidenavbar"], [class*="sidenavbar"] {
    display: none !important;
    visibility: hidden !important;
    width: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  body:has(#print_page) div[style*="marginLeft"],
  body:has(#print_page) div[style*="margin-left"] {
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    left: 0 !important;
    transform: none !important;
  }

  #print_page,
  #download_page {
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
  }

  .exam-marksheet-page-root,
  .exam-marksheet-page-root * {
    font-size: inherit !important;
  }

  .exam-marksheet-page-root .watermark-content {
    width: 100% !important;
    max-width: 100% !important;
  }

  .exam-marksheet-page-root .print-card {
    width: 100% !important;
    max-width: 100% !important;
    left: 0 !important;
    position: relative !important;
    transform: none !important;
    box-sizing: border-box !important;
    margin: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    padding-top: 0.5rem !important;
  }

  .no-print,
  .print-buttons {
    display: none !important;
  }

  /* ✅ Full-page watermark for print */
  .exam-marksheet-page-root .print-card .watermark-logo-wrapper {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    transform: none !important;
    opacity: 0.08 !important;
    z-index: 0 !important;
  }

  .print-card .watermark-logo {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain !important;
  }

  .print-card > *:not(.watermark-logo-wrapper):not(.watermark-logo) {
    position: relative !important;
    z-index: 2 !important;
  }

  /* ✅ Profile Layout Adjustments */
  .profile-print {
    display: flex !important;
    flex-direction: row !important;
    justify-content: space-between !important;
    align-items: center !important;
    flex-wrap: nowrap !important;
    gap: 0 !important;
    margin-top: -0.8rem !important;
    margin-bottom: -0.2rem !important;
    line-height: -3 !important;
  }

  .profile-print .col-md-9,
  .profile-print > .col-md-8 {
    width: 75% !important;
    flex: 0 0 75% !important;
    max-width: 75% !important;
  }

  .profile-print .col-md-3,
  .profile-print > .col-md-3 {
    width: 25% !important;
    flex: 0 0 25% !important;
    max-width: 25% !important;
    text-align: center !important;
    align-self: flex-start !important;
  }

  .profile-print .col-md-8 .row {
    display: flex !important;
    flex-direction: row !important;
  }

  .profile-print .col-md-8 .col-md-6 {
    width: 50% !important;
    flex: 0 0 50% !important;
    max-width: 50% !important;
  }

  .profile-print img {
    width: 130px !important;
    height: 130px !important;
    object-fit: cover !important;
    border: 0.5px solid #333 !important;
    display: block;
    margin: auto;
  }

  .table-head-print th {
    color: dark !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    font-size: 18px !important;
  }

  .table-body-print td {
    font-size: 18px !important;
  }

  .print-card .institute-header-text h2,
  .print-card .institute-header-text h4 {
    font-size: 16px !important;
  }

  .print-logo {
    width: 90px !important;
    height: 90px !important;
    border-radius: 50% !important;
    object-fit: cover !important;
  }

  .nielit-logo {
    width: 80px !important;
    height: 80px !important;
    margin-top: 3rem !important;
  }

  .img-nct {
    width: 50px !important;
    height: 50px !important;
  }

  .print-card .sub-header h4 {
    font-size: 16px !important;
    margin-top: -0.5rem !important;
  }

  .print-card .sub-header h5 {
    margin-top: -0.5rem !important;
  }

  .print-card .sub-header p {
    margin-top: -0.5rem !important;
    margin-bottom: -0.8rem !important;
  }


  .print-card .powered-by-footer {
    margin-top: -0.7rem !important;
  }

  .print-card .powered-by-footer .powered {
    margin-top: 1rem !important;
  }
    
}

.institute-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.institute-header-text {
    flex-grow: 1;
    text-align: center;
}

.institute-header-logo,
.institute-header-side {
    width: 120px;
    flex-shrink: 0;
}

@media print {
  .table-footer-print {
    position: fixed !important;
    bottom: 2rem !important;
    left: 0 !important;
    width: 100% !important;
    // background: #fff !important;
    z-index: 999 !important;
  }
}


/* ✅ PDF Style Fixes */
.pdf-style {
  font-size: 11px !important;
  padding: 5mm 8mm;
}

.pdf-style * {
  font-size: 11px !important;
  line-height: 1.4 !important;
}

.pdf-style h1 {
  font-size: 18px !important;
}

.pdf-style h4,
.pdf-style h5 {
  font-size: 14px !important;
}

.pdf-style p,
.pdf-style td,
.pdf-style th,
.pdf-style small {
  font-size: 11px !important;
}

.pdf-style .no-print {
  display: none !important;
}

.pdf-style .card {
  border: none !important;
  box-shadow: none !important;
}

.pdf-style .sub-header h4,
.pdf-style .sub-header h5,
.pdf-style .sub-header p {
  margin-left: auto !important;
  margin-right: auto !important;
  text-align: center !important;
}

.pdf-style .marksheet-content {
  position: relative;
  z-index: 1;
}

.pdf-style .watermark-logo-wrapper {
  width: 100% !important;
  max-width: 100% !important;
  opacity: 0.08 !important;
}

/* ============================
   PDF DOWNLOAD ONLY
   ============================ */

   .download-style  * {
    font-size: 14px !important;
  }

/* Force A4 page size for download */
.download-style .print-card-download {
  width: 100% !important;
  margin: 0 auto !important;
  box-shadow: none !important;
  border: none !important;
  height: 1123px !important; /* A4 height in pixels (297mm) */
  min-height: 1123px !important;
  max-height: 1123px !important;
  margin-top: -1rem !important;
  position: relative !important;
  page-break-inside: avoid !important;
}


 .download-style .profile-print img {
    margin-left:5rem !important;
  }

/* Container to push content */
.download-style .marksheet-content-wrapper {
  min-height: 1000px !important;
  position: relative !important;
}

/* Footer always at bottom */
.download-style .table-footer-download {
  position: absolute !important;
  bottom: -90px !important;
  left: 20px !important;
  right: 20px !important;
  margin-top: auto !important;
  z-index: 1000 !important;
   column-gap: 5rem !important;
  // padding: 10px 0 !important;
}

/* Table container with minimum height */
.download-style .table-container {
  min-height: 600px !important; /* Adjust based on your typical table height */
  position: relative !important;
}

/* Spacer to push footer down */
.footer-spacer {
  flex-grow: 1 !important;
  visibility: hidden !important;
}

/* Ensure table takes available space */
.download-style .print-card-download > .mt-3 {
  min-height: 500px !important;
  display: flex !important;
  flex-direction: column !important;
}

/* Make sure the card has relative positioning */
.download-style .print-card {
  position: relative !important;
  min-height: 280mm !important; /* Adjust based on your content */
}

.download-style .print-logo {
  border-radius: 50% !important;
  object-fit: cover !important;
  clip-path: circle(50%) !important;
}


.download-style th,
.download-style td {
  font-size: 11px !important;
  background-color: transparent !important;
  border-color: #000 !important;
}
 

.download-style .no-print{
display: none !important;
}

.overall-totals-text{
  display: flex !important;
  justify-content: center !important;
}

.download-style * {
  position: relative;
}

`
}
</style>

      <div 
        style={{ 
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px',
        }}
      >
        {/* Header */}
        <div
          className="container-fluid p-0 no-print"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px',
          }}
        >
          <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
            <div 
              className="d-flex justify-content-between align-items-center"
              style={{
                background: '#F3F4F6',
                paddingLeft: '28px',
                paddingRight: '28px',
                paddingTop: '12px',
                paddingBottom: '12px',
                overflow: 'visible',
                borderBottom: '1px solid #D1D3D4',
                width: '100%',
              }}
            >
              {/* Left: Title */}
              <div className="d-flex align-items-center gap-3">
                {/* School Logo */}
                <div style={{ 
                  width: '40px', 
                  height: '40px', 
                  borderRadius: '50%', 
                  overflow: 'hidden', 
                  background: '#223843',
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  flexShrink: 0,
                }}>
                  {!logoError ? (
                    <img 
                      src={logo} 
                      alt="School Logo" 
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      onError={() => setLogoError(true)}
                    />
                  ) : (
                    <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                  )}
                </div>
                
                <h3 
                  className="m-0 fw-bold" 
                  style={{ 
                    letterSpacing: '-0.02em',
                    overflow: 'visible',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    fontSize: 'clamp(18px, 2.5vw, 22px)',
                    color: '#223843',
                    lineHeight: '1.2',
                    fontFamily: 'Inter, system-ui, sans-serif',
                  }}
                >
                  View{' '}
                  {selectedStudentName ? `${selectedStudentName}'s` : ''}{' '}
                  Marksheet
                </h3>
              </div>
                
              {/* Right: Profile Icon with Dropdown */}
              {!isMobile && (
                <ProfileDropdown logout={logout} />
              )}
            </div>
          </div>
        </div>

        {/* Non-printable controls */}
        <div className="no-print">
          <div
            className="container-fluid p-0 mt-4"
            style={{
              paddingLeft: isCollapsed ? '32px' : '40px',
              paddingRight: '32px',
              paddingTop: '32px',
              paddingBottom: '32px',
            }}
          >
            {showNoMarksheetMessage && (
              <div
                className="mb-4 text-center"
                style={{
                  padding: '24px',
                  fontSize: '14px',
                  color: '#6b7280',
                  fontFamily: 'Inter, system-ui, sans-serif',
                }}
              >
                No marksheet is available
              </div>
            )}

            <div
              className={`d-flex flex-wrap align-items-center gap-3 mb-4 ${
                hideFilters ? 'justify-content-end' : 'justify-content-between'
              }`}
            >
              <div
                className={`d-flex flex-wrap align-items-center gap-3 ${
                  hideFilters ? 'ms-auto' : ''
                }`}
              >
                {!hideFilters && (!noMarksheetFromProfile || showFilterCard) && (
                  <button
                    onClick={() => setShowFilterCard(!showFilterCard)}
                    style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      backgroundColor: showFilterCard ? '#223843' : '#ffffff',
                      border: '1px solid #D1D3D4',
                      color: showFilterCard ? '#ffffff' : '#223843',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#223843'
                      e.currentTarget.style.color = '#ffffff'
                      e.currentTarget.style.borderColor = showFilterCard ? '#223843' : '#223843'
                      e.currentTarget.style.transform = 'scale(1.05)'
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#ffffff'
                      e.currentTarget.style.color = showFilterCard ? '#ffffff' : '#223843'
                      e.currentTarget.style.borderColor = '#D1D3D4'
                      e.currentTarget.style.transform = 'scale(1)'
                    }}
                    title={showFilterCard ? 'Hide Filters' : 'Show Filters'}
                  >
                    <BsFunnelFill size={20} />
                  </button>
                )}
                {showGoBackToolbar && (
                  <div
                    className="d-none d-md-flex align-items-center gap-2"
                    style={{ transition: 'all 0.2s ease', cursor: 'pointer' }}
                    onMouseEnter={(e) => {
                      const button = e.currentTarget.querySelector('button')
                      const text = e.currentTarget.querySelector('span')
                      if (button) {
                        button.style.backgroundColor = '#059669'
                        button.style.borderColor = '#059669'
                        button.style.transform = 'scale(1.05)'
                      }
                      if (text) {
                        text.style.transform = 'scale(1.05)'
                      }
                      e.currentTarget.style.transform = 'scale(1.02)'
                    }}
                    onMouseLeave={(e) => {
                      const button = e.currentTarget.querySelector('button')
                      const text = e.currentTarget.querySelector('span')
                      if (button) {
                        button.style.backgroundColor = '#10B981'
                        button.style.borderColor = '#10B981'
                        button.style.transform = 'scale(1)'
                      }
                      if (text) {
                        text.style.transform = 'scale(1)'
                      }
                      e.currentTarget.style.transform = 'scale(1)'
                    }}
                  >
                    <button
                      type="button"
                      onClick={() => navigate(`/student/profile/${student_id}`)}
                      style={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '50%',
                        border: '1px solid #10B981',
                        backgroundColor: '#10B981',
                        color: '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        flexShrink: 0,
                      }}
                      title="Go Back"
                    >
                      <FaArrowLeft size={20} />
                    </button>
                    <span
                      style={{
                        fontSize: '14px',
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                        fontWeight: '500',
                        transition: 'transform 0.2s ease',
                        display: 'inline-block',
                      }}
                    >
                      Go Back
                    </span>
                  </div>
                )}
                {hideFilters && hasMarksheetData && (
                  <div
                    className="d-none d-md-flex align-items-center gap-2"
                    style={{ transition: 'all 0.2s ease', cursor: 'pointer' }}
                    onClick={handlePrint}
                  >
                    <button
                      type="button"
                      style={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '50%',
                        border: '1px solid #10B981',
                        backgroundColor: '#10B981',
                        color: '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        flexShrink: 0,
                      }}
                      title="Print Marksheet"
                    >
                      <FaPrint size={20} />
                    </button>
                    <span
                      style={{
                        fontSize: '14px',
                        color: '#111827',
                        fontFamily: 'Inter, system-ui, sans-serif',
                        fontWeight: '500',
                      }}
                    >
                      Print Marksheet
                    </span>
                  </div>
                )}
              </div>

              {!hideFilters && hasMarksheetData && (
                <div
                  className="d-flex align-items-center gap-2 ms-auto"
                  style={{ transition: 'all 0.2s ease', cursor: 'pointer' }}
                  onClick={handlePrint}
                  onMouseEnter={(e) => {
                    const button = e.currentTarget.querySelector('button')
                    const text = e.currentTarget.querySelector('span')
                    if (button) {
                      button.style.backgroundColor = '#059669'
                      button.style.transform = 'scale(1.05)'
                    }
                    if (text) {
                      text.style.transform = 'scale(1.05)'
                    }
                    e.currentTarget.style.transform = 'scale(1.02)'
                  }}
                  onMouseLeave={(e) => {
                    const button = e.currentTarget.querySelector('button')
                    const text = e.currentTarget.querySelector('span')
                    if (button) {
                      button.style.backgroundColor = '#10B981'
                      button.style.transform = 'scale(1)'
                    }
                    if (text) {
                      text.style.transform = 'scale(1)'
                    }
                    e.currentTarget.style.transform = 'scale(1)'
                  }}
                >
                  <button
                    type="button"
                    style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      border: '1px solid #10B981',
                      backgroundColor: '#10B981',
                      color: '#ffffff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      flexShrink: 0,
                    }}
                    title="Print Marksheet"
                  >
                    <FaPrint size={20} />
                  </button>
                  <span
                    className="d-none d-md-inline-block"
                    style={{
                      fontSize: '14px',
                      color: '#111827',
                      fontFamily: 'Inter, system-ui, sans-serif',
                      fontWeight: '500',
                      transition: 'transform 0.2s ease',
                    }}
                  >
                    Print Marksheet
                  </span>
                </div>
              )}
              {showToolbarGenerateButton && (
              <button
                type="button"
                className="d-none d-md-flex align-items-center justify-content-center"
                onClick={handleToolbarGenerateClick}
                style={{
                  borderRadius: '10px',
                  padding: '6px 10px',
                  height: '44px',
                  border: 'none',
                  backgroundColor: '#223843',
                  color: '#ffffff',
                  gap: '6px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#1f323a'
                  e.currentTarget.style.transform = 'scale(1.03)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Generate Marksheet"
              >
                <BsFileEarmarkText size={18} />
                <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Generate Marksheet
                </span>
              </button>
              )}
            </div>

            <div
              className={`d-md-none d-flex align-items-center gap-3 mb-4 flex-wrap ${
                showGoBackToolbar ? 'justify-content-between' : 'justify-content-end'
              }`}
            >
              {showGoBackToolbar && (
                <div
                  className="d-flex align-items-center gap-2"
                  style={{ transition: 'all 0.2s ease', cursor: 'pointer' }}
                  onMouseEnter={(e) => {
                    const button = e.currentTarget.querySelector('button')
                    const text = e.currentTarget.querySelector('span')
                    if (button) {
                      button.style.backgroundColor = '#059669'
                      button.style.borderColor = '#059669'
                      button.style.transform = 'scale(1.05)'
                    }
                    if (text) {
                      text.style.transform = 'scale(1.05)'
                    }
                    e.currentTarget.style.transform = 'scale(1.02)'
                  }}
                  onMouseLeave={(e) => {
                    const button = e.currentTarget.querySelector('button')
                    const text = e.currentTarget.querySelector('span')
                    if (button) {
                      button.style.backgroundColor = '#10B981'
                      button.style.borderColor = '#10B981'
                      button.style.transform = 'scale(1)'
                    }
                    if (text) {
                      text.style.transform = 'scale(1)'
                    }
                    e.currentTarget.style.transform = 'scale(1)'
                  }}
                >
                  <button
                    type="button"
                    onClick={() => navigate(`/student/profile/${student_id}`)}
                    style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      border: '1px solid #10B981',
                      backgroundColor: '#10B981',
                      color: '#ffffff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      flexShrink: 0,
                    }}
                    title="Go Back"
                  >
                    <FaArrowLeft size={20} />
                  </button>
                  <span
                    style={{
                      fontSize: '14px',
                      color: '#111827',
                      fontFamily: 'Inter, system-ui, sans-serif',
                      fontWeight: '500',
                      transition: 'transform 0.2s ease',
                      display: 'inline-block',
                    }}
                  >
                    Go Back
                  </span>
                </div>
              )}
              {hideFilters && hasMarksheetData && (
                <button
                  type="button"
                  onClick={handlePrint}
                  style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '50%',
                    border: '1px solid #10B981',
                    backgroundColor: '#10B981',
                    color: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    flexShrink: 0,
                  }}
                  title="Print Marksheet"
                >
                  <FaPrint size={20} />
                </button>
              )}
              {showToolbarGenerateButton && (
              <button
                type="button"
                onClick={handleToolbarGenerateClick}
                style={{
                  borderRadius: '10px',
                  padding: '6px 10px',
                  height: '44px',
                  border: 'none',
                  backgroundColor: '#223843',
                  color: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '6px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#1f323a'
                  e.currentTarget.style.transform = 'scale(1.03)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Generate Marksheet"
              >
                <BsFileEarmarkText size={18} />
                <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Generate Marksheet
                </span>
              </button>
              )}
            </div>

          {/* Modern Filter Section — hidden on student marksheets view route */}
          {!hideFilters && (
          <div 
            style={{
              maxHeight: showFilterCard ? '1000px' : '0',
              overflow: showFilterCard ? 'visible' : 'hidden',
              transition: 'max-height 0.3s ease-in-out',
              marginBottom: showFilterCard ? '24px' : '0',
            }}
            className="filter-card-container"
          >
            {showFilterCard && (
              <Card 
                style={{
                  border: '1px solid #D1D3D4',
                  borderRadius: '12px',
                  backgroundColor: '#ffffff',
                  overflow: 'visible',
                  position: 'relative',
                }}
              >
                  {/* Header */}
                  <div 
                    style={{
                      background: '#ffffff',
                      padding: '20px',
                      borderBottom: '1px solid #F3F4F6',
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center gap-3">
                        <div 
                          style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: '#223843',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <BsSearch style={{ color: '#ffffff', fontSize: '18px' }} />
                        </div>
                        <div>
                          <h5 className="m-0 fw-semibold text-start" style={{ color: '#111827', fontSize: '16px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Search & Filter Marksheet
                          </h5>
                          <p className="m-0 mt-1" style={{fontSize: '13px', color: '#6b7280' }}>
                            Select course, class, and student to view marksheet
                          </p>
                        </div>
                      </div>
                      <button
                        onClick={handleRefresh}
                        style={{
                          width: '48px',
                          height: '48px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          border: 'none',
                          color: '#ffffff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1.05)'
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1)'
                        }}
                        title="Refresh"
                      >
                        <BsArrowClockwise size={20} />
                      </button>
                    </div>
                  </div>

                  <Card.Body className="p-4" style={{ backgroundColor: '#ffffff', overflow: 'visible', position: 'relative', zIndex: 1 }}>
                    <Row className="g-4 text-start">
                      {/* Course Selection */}
                      <Col xs={12} md={4}>
                        <div style={{ position: 'relative' }}>
                          <label className="fw-semibold mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Select Course
                          </label>
                          <Typeahead
                            id="course-select"
                            labelKey="name"
                            onChange={(selected) => {
                              const course = selected[0]
                              if (course) {
                                handleCourseChange({
                                  target: { value: course.id },
                                })
                              } else {
                                handleCourseChange({ target: { value: '' } })
                              }
                            }}
                            options={courses}
                            placeholder="Select Course"
                            selected={courses.filter(
                              (cs) => cs.id === Number(selectedCourse),
                            )}
                            inputProps={{
                              style: {
                                borderRadius: '8px',
                                border: '1px solid #D1D3D4',
                                fontSize: '14px',
                                height: '40px',
                                transition: 'all 0.2s ease',
                                backgroundColor: '#ffffff',
                                fontFamily: 'Inter, system-ui, sans-serif',
                              }
                            }}
                          />
                        </div>
                      </Col>

                      {/* Class Selection */}
                      <Col xs={12} md={4}>
                        <div style={{ position: 'relative' }}>
                          <label className="fw-semibold mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Select Class
                          </label>
                          <Typeahead
                            id="class-select"
                            labelKey="class_name"
                            onChange={(selected) => {
                              const cls = selected[0]
                              if (cls) {
                                handleClassChange({ target: { value: cls.id } })
                              } else {
                                handleClassChange({ target: { value: '' } })
                              }
                            }}
                            options={classes}
                            placeholder="Select Class"
                            selected={classes.filter((cs) => cs.id === Number(selectedClass))}
                            inputProps={{
                              style: {
                                borderRadius: '8px',
                                border: '1px solid #D1D3D4',
                                fontSize: '14px',
                                height: '40px',
                                transition: 'all 0.2s ease',
                                backgroundColor: '#ffffff',
                                fontFamily: 'Inter, system-ui, sans-serif',
                              }
                            }}
                          />
                        </div>
                      </Col>

                      {/* Student Selection */}
                      <Col xs={12} md={4}>
                        <div style={{ position: 'relative' }}>
                          <label className="fw-semibold mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Select Student
                          </label>
                          <Typeahead
                            id="student-select"
                            labelKey={(option) =>
                              option?.name ||
                              option?.student_name ||
                              `Student #${option?.id ?? ''}`
                            }
                            onChange={(selected) => {
                              const st = selected[0]
                              if (st) {
                                handleStudentChange({ target: { value: st.id } })
                              } else {
                                handleStudentChange({ target: { value: '' } })
                              }
                            }}
                            onClick={handleStudentMarksheet}
                            options={students}
                            placeholder="Select Student"
                            selected={
                              selectedStudent
                                ? students.filter(
                                    (st) => Number(st.id) === Number(selectedStudent),
                                  )
                                : []
                            }
                            inputProps={{
                              style: {
                                borderRadius: '8px',
                                border: '1px solid #D1D3D4',
                                fontSize: '14px',
                                height: '40px',
                                transition: 'all 0.2s ease',
                                backgroundColor: '#ffffff',
                                fontFamily: 'Inter, system-ui, sans-serif',
                              }
                            }}
                          />
                        </div>
                      </Col>
                    </Row>

                  </Card.Body>
                </Card>
              )}
            </div>
          )}
          </div>
        </div>
     
      {data && selectedStudent && showMarksheet ? (
        <div id="download_page">
        <div 
        id="print_page"
          // ref={componentRef}
          // className="mt-4 w-100 position-relative watermark-container"
          className="position-relative watermark-container"
          style={{ display: showMarksheet ? 'block' : 'none', marginTop: '0' }}>
           
          
           
          <div className="watermark-content">
        
              <Card className="p-4 shadow-sm border-dark rounded-2 print-card print-card-download">
              <div className="watermark-logo-wrapper">
              <img
                src={Cookies.get('institute_logo') || '/markWatermark.png'}
                alt="Watermark Logo"
                className="watermark-logo"
                onError={(e) => {
                  e.currentTarget.onerror = null
                  e.currentTarget.src = '/markWatermark.png'
                }}
              />
            </div>
                <div className="d-flex justify-content-between align-items-center institute-header">
                  <div className="me-5 institute-header-logo">
                    <Image
                      src={logo}
                      alt="Logo"
                    className="print-logo"
                      style={{ width: '90px', height: '90px', borderRadius: '50%' }}
                    />
                  </div>

                  <div className='institute-header-text' style={{color:"blue"}}>
                    <h2 className="fw-bold mb-2">{instituteName}</h2>
                    <h4 className="fw-bold">
                      {instituteAddress} - {institutePincode}
                    </h4>
                    {!hideNctBranding && (
                        <p className="powered" style={{ fontStyle: 'italic', fontSize: '14px', fontWeight:"600" }}>
                      Powered by <strong>Tera Tujko Arpan (ISO 9001 : 2015)</strong>
                    </p>
                    )}
                  </div>
                  
                  <div className="institute-header-side text-center">
                    {!hideNctBranding && (
                      <>
                        <img
                          src="/nct_logo2.png"
                          alt="NCT Logo"
                          className="img-nct"
                          style={{ width: '70px', height: '70px' }}
                        />
                        <div className='gvt' style={{ fontSize: '10px', fontWeight: 'bold', marginTop: '4px' }}>
                          GOVERNMENT OF NCT OF DELHI
                        </div>
                      </>
                    )}
                  </div>
                </div>
                {/* <div className='sub-header '>
                  <hr />
                  <h4 className="text fw-bold text-uppercase">
                    {data[0]?.course?.name}
                  </h4>
                  <h5 className=" fw-semibold  mt-0">Student Result</h5>
                  <p className="text-muted fw-semibold">Session : {data[0]?.exam?.session}</p>
                  <hr style={{ marginTop: '1rem' }} />
                </div> */}

               {/* <div className='sub-header'> */}

                <hr />
                <div className="sub-header d-flex align-items-center justify-content-between position-relative">
                  {/* <img
                    src="/nielit.png"
                    alt="Logo"
                    style={{ width: '100px', height: '100px',position: 'absolute', marginTop:"4rem" }}                    
                     className="nielit-logo"
                  /> */}
                  <h4 className="text fw-bold text-uppercase w-100 text-center m-0">
                    {data[0]?.course?.name}
                  </h4>
                </div>

              <div className="text-center">
                <h5 className="fw-semibold mt-0">Student Result</h5>
                <p className="text-muted fw-semibold">Session : {data[0]?.exam?.session}</p>
              </div>
                <hr style={{ marginTop: '1rem' }} />
              {/* </div> */}

                <Row className="text-start align-items-center profile-print">
                  <Col xs={12} md={8}>
                    <Row>
                      <Col xs={12} md={6}>
                        <p>
                          <strong>Admission Number :{' '}
                          {data[0]?.student?.admission_number}</strong>
                        </p>
                       
                        <p>
                        <strong>Marksheet Number  : MS-2025-{data[0]?.course?.id}-{data[0]?.student?.id}</strong>
                        </p>
                        <p>
                          <strong>Father's Name :{' '}
                          {data[0]?.student?.father_name}</strong>
                        </p>
                        
                        <p>
                          <strong>
                            Roll Number :{' '}
                            {allStudents.find(
                              (s) =>
                                Number(s.id) ===
                                Number(
                                  selectedStudent || data[0]?.student?.id,
                                ),
                            )?.roll_number ||
                              data[0]?.student?.roll_number ||
                              ''}
                          </strong>
                        </p>
                      </Col>

                      <Col xs={12} md={6}>
                      <p>
                          <strong>NAME OF STUDENT :{' '}
                          {data[0]?.student?.name}</strong>
                        </p>
                        <p>
                          <strong>Date of Birth :{' '}
                          {data[0]?.student?.dob
                            ? new Date(data[0].student.dob).toLocaleDateString(
                                'en-GB',
                                {
                                  day: 'numeric',
                                  month: 'long',
                                  year: 'numeric',
                                },
                              )
                            : ''}</strong>
                        </p>
                        <p>
                          <strong>Mother's Name :{' '}
                          {data[0]?.student?.mother_name}</strong>
                        </p>
                        {/* <p>
                          <strong>Marksheet Number</strong> : {data[0]?.student?.marksheet_number || "N/A"}
                        </p> */}
                       
                      </Col>
                    </Row>
                  </Col>

                  <Col xs={12} md={3} className="text-center mt-md-0">
                    <Image
                      src={resolveStudentImageSrc(
                        pickStudentImageRaw(
                          img?.student_image,
                          img?.image,
                          data[0]?.student?.student_image,
                          location.state?.studentImage,
                          location.state?.student?.student_image,
                          (() => {
                            const s = allStudents.find(
                              (row) =>
                                Number(row.id) ===
                                Number(selectedStudent || student_id),
                            )
                            return (
                              s?.student_image ||
                              s?.image ||
                              s?.photo ||
                              s?.profile_image
                            )
                          })(),
                        ),
                      )}
                       style={{ width: '120px', height: '120px', objectFit: 'cover', border: '1px solid #333' }}
                       className="mt-2"
                      alt="Student"
                      onError={(e) => {
                        if (e.currentTarget.src.endsWith(DEFAULT_STUDENT_PHOTO)) return
                        e.currentTarget.onerror = null
                        e.currentTarget.src = DEFAULT_STUDENT_PHOTO
                      }}
                    />
                  </Col>
                </Row> 
                <hr />
                <div className="mt-3">
                  <Table striped bordered hover className="text-center marksheet-table">
                    <thead className=" text-dark table-head-print" style={{
                      backgroundColor:"white"
                    }}>
                      <tr>
                        <th>S. No.</th>
                        <th>Subject</th>
                      
                       
                        {uniqueExams.map(([examId, examName ], i) => (
                        <th key={i} >
                       {examName} 
                       <Button
                        variant="link"  
                        style={{marginTop:"-6px"}}
                        onClick={() => handleEditMarksheet(examId)}
                        className="ms-5 p-0 btn btn-link link-danger text-decoration-none justify-content-end no-print"
 
                      >
                        [ <FaEdit size={14} /> Edit ]
                      </Button>
                    </th>
                  ))}
                        <th>Cumulative</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody className='table-body-print' style={{fontWeight:"bold"}}>
                  {processedSubjects.map((subject, index) => (
                    <tr key={index} 
                    // style={{backgroundColor:"#F3F8F6"}}
                    >
                      <td>{index + 1}</td>
                      <td>{subject.subjectName}</td>
                      {examNames.map((exam, i) => {
                        const totalMarks = examTotalMarksMap.get(exam); // total marks for that exam
                        const subjectExam = subject.exams[exam]; // marks for this subject in that exam

                        return (
                          <td key={i}>
                            {subjectExam ? (
                              <div>
                                <div className="small fw-bold">{subjectExam.marks} | {totalMarks}</div>
                              </div>
                            ) : (
                              '-'
                            )}
                          </td>
                        );
                      })}
                      <td>{subject.average}</td>
                      <td className={subject.finalStatus === "Pass" ? "text-success" : "text-danger"}>
                        {subject.finalStatus}
                      </td>
                    </tr>
                  ))}
                  </tbody> 


                  </Table>

                  <div className='fw-bold overall-totals-text'>
                    <p>
                      Total Marks Obtained: {overallTotals.totalObtained} / {overallTotals.totalMax}
                      &nbsp;&nbsp; | &nbsp;&nbsp;
                      Overall Percentage: {overallTotals.percentage}%
                    </p>
                  </div>


                </div>

                <div>
                  <div className="justify-content-between d-flex mt-5 table-footer-print table-footer-download">
                    <p className="fw-bold">
                    Verified By_______________________________________________
                  </p>
                  <p className="fw-bold">
                    Authorized
                    Signature_______________________________________________
                  </p>
                </div>
                </div>
              </Card>
          </div>
        </div>
        </div>
      ) : null} 
    </div>
    </>
  )
}
